import { Component, OnInit } from "@angular/core";
import { Response } from "@angular/http";
import { ActivatedRoute, Router } from "@angular/router";
import { Customer } from "app/_models/customer";
import { CustomersService } from "app/_services/customers.service";

@Component({
    selector: "app-userpermission",
    templateUrl: "./userpermission.component.html",
    providers: [CustomersService]
})
export class UserPermissionComponent implements OnInit {

    private permissionAnswer : string;
    private success : boolean = false;
    private customerLoading : boolean = true;
    private loading : boolean;
    private chassisNumber : string;
    private customerEmail : string;
    private customerName : string;
    private customerMauticId : string;
    private customer : Customer;

    constructor(
        private activatedRoute : ActivatedRoute,
        private router : Router,
        private customerService : CustomersService) 
    {    
    }

    ngOnInit() : void {

        // Get chassis number & email from URL params
        this.activatedRoute.queryParams.subscribe((param: any) => {
            this.chassisNumber = param["chassis"];
            this.customerEmail = param["email"];
        });

        // If user with that chassis number exists continue, else redirect to login
        if (!this.chassisNumber || !this.customerEmail) {
            this.router.navigate(['login']);
        }

        this.customerService.findByChassisNumberAndEmail(this.chassisNumber, this.customerEmail)
            .subscribe(
                p => this.customer = p,
                e => console.error(e),
                () => {
                    if (!this.customer.mauticId) {
                        this.router.navigate(['login']);
                    }
                    else {
                        this.customerLoading = false;
                        this.customerName = this.customer.name;
                        this.customerMauticId = this.customer.mauticId;
                    }
                }
            )
    }

    updatePermission() : void {
        this.success = false;
        this.loading = true;
        let response : Response;
        let answerBool = this.permissionAnswer == "true";
        this.customerService.setPermission(answerBool, this.customerMauticId)
            .subscribe(
                p => response = p,
                e => console.error(e),
                () => {
                    if (response.ok) {
                        this.loading = false;
                        this.success = true;
                    }
                    else {
                        alert("something went wrong!");
                        this.loading = false;
                    }
                }
            );
    }
}


// WEBPACK FOOTER //
// ./src/app/landingpages/userpermission/userpermission.component.ts